"use strict";
/**
 * Agent event types published on the per-brand Redis Pub/Sub channel
 * `agent-events:{brandUuid}` and delivered to clients over SSE.
 *
 * These types are the wire format between the API publisher and the
 * frontend consumer. They are additive by design — new fields or new
 * event variants must not break older clients that ignore unknown
 * properties and discriminants.
 *
 * NOTE: this file is inside the `shared` package which MUST NOT depend
 * on `database` (Prisma). `AgentStatus` is therefore mirrored here as a
 * string literal union. If the Prisma enum changes, this file must be
 * updated in the same PR.
 */
Object.defineProperty(exports, "__esModule", { value: true });
